<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div class="modal fade show modal-dialog-scrollable" style="display: block;">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Лист заключений.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <div class="font-weight-bold">Диагноз МКБ:</div>

              <div
                  v-for="diagnosis in diagnosisData"
                  :key="diagnosis.id">
                {{diagnosis.title}}
              </div>
            </div>

            <div class="mb-3">
              <div class="font-weight-bold">Диагноз МКФ:</div>

              <div
                  v-for="functional in functionalData"
                  :key="functional.id">
                {{functional.title}}
              </div>
            </div>

            <div>
              <div class="font-weight-bold">Диагностическое представление о пациенте:</div>

              <div
                  v-for="conclusion in conclusions"
                  :key="conclusion.id">
                {{conclusion.text}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientConclusionTotal',

  props: ['conclusions', 'diagnoses', 'diagnosisEstablishments', 'functionals', 'functionalEstablishments'],

  components: {},

  data() {
    return {
    };
  },

  computed: {
    diagnosisData() {
      return this.diagnosisEstablishments
          .filter(i => i.dateTo === null)
          .map(item => {
            const diagnosis = this.diagnoses.find(i => i.id === item.diagnosis);

            return {
              id: item.id,
              title: diagnosis ? diagnosis.title : '',
            };
          });
    },

    functionalData() {
      return this.functionalEstablishments
          .filter(i => i.dateTo === null)
          .map(item => {
            const functional = this.functionals.find(i => i.id === item.functional);

            return {
              id: item.id,
              title: functional ? functional.title : '',
            };
          });
    },
  },

  methods: {
  },
};
</script>
